import { render, staticRenderFns } from "./PartnerAnalyticsDetails.vue?vue&type=template&id=54010a77&scoped=true"
import script from "./PartnerAnalyticsDetails.vue?vue&type=script&lang=js"
export * from "./PartnerAnalyticsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54010a77",
  null
  
)

export default component.exports